import React from 'react'
import { SESSION_OBJECTIVES, OBJECTIVES_LEAD } from '../content/objectivesScreen'
import './objectives.scss'

// Learning objectives for the session.
//
// A dedicated screen rather than an instructions screen pushed through RichText: that
// renderer gives one flat bullet style, which turned five objectives into a paragraph of
// list. Here the objectives are the only thing at full contrast — the heading says what
// they are, everything else is quiet, and the eye can land on five short lines.
export default function ObjectivesStep ({ onAdvance, busy }) {
  return (
    <div className="study-card obj">
      <div className="obj__head">
        <h2 className="obj__title">Learning objectives</h2>
        <p className="obj__lead">{OBJECTIVES_LEAD}</p>
      </div>

      {/* Numbered continuously across groups, not restarting per group: there are five
          objectives for the session, and two lists both starting at 1 would read as two
          separate sets of things rather than one set of five. */}
      <div className="obj__groups">
        {SESSION_OBJECTIVES.reduce((acc, group) => {
          acc.nodes.push(
            <section className="obj__group" key={group.domain}>
              <h3 className="obj__group-title">{group.title}</h3>
              <ol className="obj__list">
                {group.items.map(item => {
                  const n = ++acc.n
                  return (
                    <li className="obj__item" key={item.text}>
                      <span className="obj__num">{n}</span>
                      <span>{item.text}</span>
                    </li>
                  )
                })}
              </ol>
            </section>
          )
          return acc
        }, { nodes: [], n: 0 }).nodes}
      </div>

      <div className="study-actions">
        <button className="study-btn study-btn--primary" disabled={busy} onClick={() => onAdvance({ seen: true })}>
          {busy ? '…' : 'Continue'}
        </button>
      </div>
    </div>
  )
}
